import React from 'react';

const PaperRating = () => (
  <div className="rating-section">
          <div className="question">Bu yazıyı faydalı buldunuz mu?</div>
          <div className="rating-buttons">
              <span className="rating-button">
                  <i className="material-icons">sentiment_very_dissatisfied</i>
              </span>
              <span className="rating-button">
                  <i className="material-icons">sentiment_neutral</i>
              </span>
              <span className="rating-button">
                  <i className="material-icons">sentiment_very_satisfied</i>
              </span>
          </div>
  </div>
);

export default PaperRating;
